import { RestService } from "./RestService";

export class MovieCrewService extends RestService {
  constructor() {
    super("/api/v1/movie_crews");
  }
}